<template>
	<div class="relative w-full pt-8 overflow-x-hidden">
		<div class="relative grid mx-auto w-full max-w-[1200px] px-10">
			<div
				class="absolute w-full h-full scale-150 z-10 bg-cover bg-top bg-no-repeat"
				style="background-image: url('images/other/island-2.png');"
			></div>

			<div class="pb-12"></div>

			<span class="relative mt-auto z-20 text-xl md:text-2xl lg:text-3xl font-semibold font-display text-brown">
				{{ $t('global.locationTitle') }}
			</span>

			<div class="pb-4"></div>
		</div>
		
		<div class="relative w-full bg-blue md:px-10 md:py-10 z-10">
			<div class="relative w-full lg:max-w-[1200px] mx-auto flex flex-col justify-center items-start gap-4 text-brown">
				<div class="w-full grid grid-rows-2 md:grid-rows-1 md:grid-cols-2">
					<div class="grid place-content-center p-8">
						<div class="max-w-full w-72 sm:w-96 md:w-80 lg:w-[22rem] h-80 z-0">
							<LMap 
								ref="map" 
								:zoom="8" 
								:min-zoom="6"
								:max-zoom="16"
								:max-bounds="[infoConfig.coords, infoConfig.coords]"
								:center="infoConfig.coords"
							>
								<LTileLayer
									url="https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
									layer-type="base"
									name="GoogleRoadMap"
								></LTileLayer>
								<LMarker :lat-lng="infoConfig.coords">
									<LIcon :icon-anchor="[15, 30]">
										<a :href="infoConfig.googleMapsLink" target="_blank">
											<PinIcon :width="30" :height="30" color="#3C2B05" />
										</a>
									</LIcon>
								</LMarker>
							</LMap>
						</div>
					</div>

					<div class="h-full flex flex-col justify-start md:justify-center items-start gap-6 py-8 px-10 md:px-0">
						<a :href="infoConfig.googleMapsLink" target="_blank" class="flex justify-start items-center gap-3">
							<PinIcon :width="30" :height="30" color="#3C2B05" />
							<span class="font-display text-lg md:text-xl lg:text-2xl font-normal">
								{{ infoConfig.address }}
							</span>
						</a>
						<a :href="infoConfig.wappLink" target="_blank" class="flex justify-start items-center gap-3">
							<WhatsappIcon :width="30" :height="30" color="#3C2B05" />
							<span class="font-display text-lg md:text-xl lg:text-2xl font-normal">
								{{ infoConfig.phone}}
							</span>
						</a>
						<a :href="`mailto:${infoConfig.email}`" target="_blank" class="flex justify-start items-center gap-3">
							<EmailIcon :width="30" :height="30" color="#3C2B05" />
							<span class="font-display text-lg md:text-xl lg:text-2xl font-normal">
								{{ infoConfig.email }}
							</span>
						</a>
						<a v-if="infoConfig.facebook" :href="infoConfig.facebook" target="_blank" class="flex justify-start items-center gap-3">
							<FacebookIcon :width="30" :height="30" color="#3C2B05" />
							<span class="font-display text-lg md:text-xl lg:text-2xl font-normal">
								{{ infoConfig.name}}
							</span>
						</a>
					</div>
				</div>
			</div>

			<Footer text-color="text-brown" />
		</div>
	</div>
</template>

<script>
import PinIcon from './icons/PinIcon.vue';
import WhatsappIcon from './icons/WhatsappIcon.vue';
import EmailIcon from './icons/EmailIcon.vue';
import FacebookIcon from './icons/FacebookIcon.vue';

import { infoConfig } from '../assets/config/infoConfig';

import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker, LIcon } from "@vue-leaflet/vue-leaflet";

import Footer from './graphics/Footer.vue';

export default {
	name: 'InfoPage',
	components: {
		PinIcon,
		WhatsappIcon,
		FacebookIcon,
		EmailIcon,
		LMap,
		LTileLayer,
		LMarker,
		LIcon,
		Footer,
	},
	setup() {
		return {
			infoConfig,
		};
	},
	data() {
		return {
			zoom: 8,
		};
	},
};
</script>
